module.exports = __webpack_public_path__ + "static/media/tradeMarkPatent_40-1621861.fb017c5e.png";